import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Leaf, LogOut } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuLabel } from "@/components/ui/dropdown-menu";
import CurrencySelector from "@/components/CurrencySelector";
import CartDrawer from "@/components/CartDrawer";

const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const linkCls = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${isActive ? "text-[#2C5530] font-medium" : "text-stone-600 hover:text-[#2C5530]"}`;

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 bg-[#2C5530] rounded-xl flex items-center justify-center">
            <Leaf className="w-5 h-5 text-white" strokeWidth={2} />
          </div>
          <span className="font-medium tracking-tight text-lg" style={{fontFamily:'Work Sans'}}>Carbon Vaults</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/marketplace" data-testid="nav-marketplace" className={linkCls}>Marketplace</NavLink>
          <NavLink to="/enterprise" data-testid="nav-enterprise" className={linkCls}>Enterprise</NavLink>
          <NavLink to="/ai-assistant" data-testid="nav-ai" className={linkCls}>AI Advisor</NavLink>
          {user && <NavLink to="/dashboard" data-testid="nav-dashboard" className={linkCls}>Dashboard</NavLink>}
          {user?.is_admin && <NavLink to="/admin" data-testid="nav-admin" className={linkCls}>Admin</NavLink>}
        </nav>

        <div className="flex items-center gap-3">
          <CurrencySelector />
          <CartDrawer />
          {!user ? (
            <>
              <Link to="/login">
                <Button variant="ghost" data-testid="nav-login-btn" className="text-stone-700">Sign in</Button>
              </Link>
              <Link to="/register">
                <Button data-testid="nav-register-btn" className="bg-[#2C5530] hover:bg-[#1F3D22] text-white rounded-full px-5">
                  Get started
                </Button>
              </Link>
            </>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" data-testid="nav-user-menu" className="rounded-full border-stone-200">
                  {user.company_name?.split(" ")[0] || "Account"}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-white">
                <DropdownMenuLabel>{user.email}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => nav("/dashboard")} data-testid="menu-dashboard">Dashboard</DropdownMenuItem>
                <DropdownMenuItem onClick={() => nav("/marketplace")}>Marketplace</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); nav("/"); }} data-testid="menu-logout">
                  <LogOut className="w-4 h-4 mr-2" /> Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
